import * as React from "react"
import { Helmet } from "react-helmet"
import Layout from "../../../components/layout/layout"
import NodeJS from "../../../images/nodejs.png"
import { CATEGORY_LABELS } from "../../../constants/posts"

import * as S from "../../../styles/styles"

const TITLE = "Полное руководство: настройка Node.js с автозапуском и .htaccess"

const CompleteGuideAutoStartNodeJs = () => (
  <Layout lang="ru" postTitle={TITLE}>
    <Helmet>
      <title>
        Полное руководство: настройка Node.js с автозапуском и .htaccess
      </title>
      <meta
        name="description"
        content="Полное руководство по настройке Node.js с автозапуском и .htaccess. Узнайте, как установить Node.js, настроить PM2, создать автозапуск через Crontab и использовать .htaccess для правильного отображения вашего сайта."
      />
      <meta
        name="keywords"
        content=".AM,.ՀԱՅ,.ORG,.COM,.NET,.INFO, network am, interneti kargavorum, հոսթինգ, network am, abc internet,  am am, домейн, domeyn,  armenian web hosting,  фь, network am, hosting am, inet am,  host am,  www nane am,  hosting armenia,  armenia domain,  abc am,  domen am,  am name  .GROUP и регистрация доменов в ряде других зон, начиная с годовой стоимости 2400 драм. 24/7 поддержка Hosting,SSL,Constructor"
      />
      <meta property="og:title" content="Управление DNS" />
      <meta
        property="og:description"
        content="Полное руководство по настройке Node.js с автозапуском и .htaccess. Узнайте, как установить Node.js, настроить PM2, создать автозапуск через Crontab и использовать .htaccess для правильного отображения вашего сайта."
      />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="ABC Domain LLC" />
      <meta
        property="og:image"
        content="https://internet.am/images/fb_logo.png"
      />
      <meta name="twitter:card" content="summary" />
      <meta
        name="twitter:title"
        content="Полное руководство: настройка Node.js с автозапуском и .htaccess"
      />
      <meta
        name="twitter:description"
        content="Полное руководство по настройке Node.js с автозапуском и .htaccess. Узнайте, как установить Node.js, настроить PM2, создать автозапуск через Crontab и использовать .htaccess для правильного отображения вашего сайта."
      />
      <meta
        name="twitter:image"
        content="https://internet.am/images/fb_logo.png"
      />
    </Helmet>
    <S.PageWrap>
      <S.ArticleWrap>
        <S.ArticleInner>
          <S.ArticleMetaRow>
            <S.PillBlue>{CATEGORY_LABELS.hosting.ru}</S.PillBlue>
            <S.MonoDate>30.05.2025</S.MonoDate>
          </S.ArticleMetaRow>
          <S.ArticleH1>{TITLE}</S.ArticleH1>
          <S.CoverImage src={NodeJS} alt={TITLE} />

          <S.ArticleBody>
            <h2>1. Установка Node.js</h2>
            <pre>
              <code>
                cd /home/USER_DIR/bin export
                <br />
                PATH=/home/USER_DIR/bin/node-v22.11.0-linux-x64/bin:$PATH
                <br />
                node
                <br />
                -v npm -v
              </code>
            </pre>
            <h2>2. Установка и настройка PM2</h2>
            <pre>
              <code>
                npm install -g pm2
                <br />
                pm2 start /home/USER_DIR/server/server.js --name mynodeapp
                <br />
                pm2 save
              </code>
            </pre>
            <h2>3. Автозапуск через Crontab</h2>
            <pre>
              <code>crontab -e</code>
            </pre>
            <p>Добавьте следующую строку:</p>
            <pre>
              <code>
                @reboot /bin/bash -c 'source /home/USER_DIR/.bashrc &&
                <br />
                /home/USER_DIR/bin/node-v22.11.0-linux-x64/lib/node_modules/pm2/bin/pm2
                <br />
                resurrect'
              </code>
            </pre>
            <h2>4. Пример файла .bashrc</h2>
            <pre>
              <code>
                if [ -f /etc/bashrc ]; then
                <br />
                . /etc/bashrc
                <br />
                fi
                <br />
                export NODE_HOME=/home/USER_DIR/bin/node-v22.11.0-linux-x64
                <br />
                export PATH=$NODE_HOME/bin:$HOME/.local/bin:$PATH
                <br />
                if command -v pm2 &gt; /dev/null 2&gt;&amp;1; then
                <br />
                nohup pm2 resurrect &gt; $HOME/pm2.log 2&gt;&amp;1 &amp;
                <br />
                fi
              </code>
            </pre>
            <h2>5. Настройка .htaccess</h2>
            <pre>
              <code>
                RewriteEngine On
                <br />
                RewriteRule ^(.*)$ http://127.0.0.1:3000/$1 [P,L]
              </code>
            </pre>
            <h2>6. Логи Apache</h2>
            <pre>
              <code>
                tail -f /etc/apache2/logs/domlogs/USER_DIR/error_log
                <br />
                tail -f /etc/apache2/logs/domlogs/USER_DIR/access_log
              </code>
            </pre>
            <h2>7. Проверка установки</h2>
            <pre>
              <code>pm2 list</code>
            </pre>
            <p>Откройте в браузере:</p>
            <pre>
              <code>http://yourdomain.com/</code>
            </pre>
            <h2>⚠️ Важно:</h2>
            <p>
              <strong>
                Перед запуском в продакшн обязательно уточните у администратора
                хостинга, какой порт вам разрешено использовать. Никогда не
                предполагаете, что это будет порт 3000!
              </strong>
            </p>
            <S.Copyright>
              &copy; 2023 Internet.am. All rights reserved.
            </S.Copyright>
          </S.ArticleBody>
        </S.ArticleInner>
      </S.ArticleWrap>
    </S.PageWrap>
  </Layout>
)

export default CompleteGuideAutoStartNodeJs
